//#region Send Notification

import {
  AdminSentNotificationDto,
  PaginateQuery,
  SendNotificationRequest,
  SendNotificationV3Request,
} from "../../interfaces";
import { Paginated } from "../../models";

export const SEND_NOTIFICATION = "SEND_NOTIFICATION";
export const SEND_NOTIFICATION_SUCCESS = "SEND_NOTIFICATION_SUCCESS";
export const SEND_NOTIFICATION_ERROR = "SEND_NOTIFICATION_ERROR";
export const RESET_SEND_NOTIFICATION = "RESET_SEND_NOTIFICATION";

export interface SendNotificationAction {
  type: typeof SEND_NOTIFICATION;
  payload: {
    request: SendNotificationRequest;
  };
}

export interface SendNotificationSuccessAction {
  type: typeof SEND_NOTIFICATION_SUCCESS;
  payload: null;
}

export interface SendNotificationErrorAction {
  type: typeof SEND_NOTIFICATION_ERROR;
  payload: any;
}

export interface ResetSendNotificationAction {
  type: typeof RESET_SEND_NOTIFICATION;
  payload: any;
}
//#endregion

//#region Send Notification V3

export const SEND_NOTIFICATION_V3 = "SEND_NOTIFICATION_V3";
export const SEND_NOTIFICATION_V3_SUCCESS = "SEND_NOTIFICATION_V3_SUCCESS";
export const SEND_NOTIFICATION_V3_ERROR = "SEND_NOTIFICATION_V3_ERROR";
export const RESET_SEND_NOTIFICATION_V3 = "RESET_SEND_NOTIFICATION_V3";

export interface SendNotificationV3Action {
  type: typeof SEND_NOTIFICATION_V3;
  payload: {
    request: SendNotificationV3Request;
  };
}

export interface SendNotificationV3SuccessAction {
  type: typeof SEND_NOTIFICATION_V3_SUCCESS;
  payload: null;
}

export interface SendNotificationV3ErrorAction {
  type: typeof SEND_NOTIFICATION_V3_ERROR;
  payload: any;
}

export interface SendNotificationV3ErrorAction {
  type: typeof SEND_NOTIFICATION_V3_ERROR;
  payload: any;
}

export interface ResetSendNotificationV3Action {
  type: typeof RESET_SEND_NOTIFICATION_V3;
  payload: any;
}
//#endregion

//#region Get Admin Sent Notifications

export const GET_ADMIN_SENT_NOTIFICATIONS = "GET_ADMIN_SENT_NOTIFICATIONS";
export const GET_ADMIN_SENT_NOTIFICATIONS_SUCCESS: any =
  "GET_ADMIN_SENT_NOTIFICATIONS_SUCCESS";
export const GET_ADMIN_SENT_NOTIFICATIONS_ERROR: any =
  "GET_ADMIN_SENT_NOTIFICATIONS_ERROR";

export interface GetAdminSentNotificationsAction {
  type: typeof GET_ADMIN_SENT_NOTIFICATIONS;
  payload: {
    request: PaginateQuery;
    history: History;
  };
}

export interface GetAdminSentNotificationsSuccessAction {
  type: typeof GET_ADMIN_SENT_NOTIFICATIONS_SUCCESS;
  payload: Paginated<AdminSentNotificationDto>;
}

export interface GetAdminSentNotificationsErrorAction {
  type: typeof GET_ADMIN_SENT_NOTIFICATIONS_ERROR;
  payload: any;
}
//#endregion

//#region Delete Notification

export const DELETE_NOTIFICATION_CONSENT: any = "DELETE_NOTIFICATION_CONSENT";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const DELETE_NOTIFICATION_SUCCESS: any = "DELETE_NOTIFICATION_SUCCESS";
export const DELETE_NOTIFICATION_ERROR: any = "DELETE_NOTIFICATION_ERROR";

export interface DeleteNotificationConsentAction {
  type: typeof DELETE_NOTIFICATION_CONSENT;
  payload: string;
}

export interface DeleteNotificationAction {
  type: typeof DELETE_NOTIFICATION;
  payload: {
    id: string;
  };
}

export interface DeleteNotificationSuccessAction {
  type: typeof DELETE_NOTIFICATION_SUCCESS;
  payload: null;
}

export interface DeleteNotificationErrorAction {
  type: typeof DELETE_NOTIFICATION_ERROR;
  payload: any;
}
//#endregion

export type ActionTypes =
  | SendNotificationAction
  | SendNotificationSuccessAction
  | SendNotificationErrorAction
  | ResetSendNotificationAction
  | SendNotificationV3Action
  | SendNotificationV3SuccessAction
  | SendNotificationV3ErrorAction
  | ResetSendNotificationV3Action
  | GetAdminSentNotificationsAction
  | GetAdminSentNotificationsErrorAction
  | GetAdminSentNotificationsSuccessAction
  | DeleteNotificationAction
  | DeleteNotificationConsentAction
  | DeleteNotificationErrorAction
  | DeleteNotificationErrorAction;
